// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2fedc310","455":"ab81e45d","977":"2c2446b1"}[chunkId] + ".chunk.js";
};